export interface ConfigureTimeSeriesOperationResult {
    raftCommandIndex: number;
}